// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"275a49f2","313":"3646b1dc"}[chunkId] + ".css";
};